const PageCategory = ({ page }) => {
  const base_url = process.env.PUBLIC_URL;
  return (
    <>
      <div className="step-header" style={{ backgroundColor: `${page.color}`, background: `${page.color}` }}>
        <div className="step-header-wrapper">
          <h1 className="category-title">
            {page.id.substring(1)}. {page.title}
          </h1>
          <h3 className="category-text">{page.content}</h3>
        </div>
      </div>

      <div className="step-footer"></div>
    </>
  );
};

export default PageCategory;
